import { useMemo } from "react";
import { useAppStore } from "@/store";
import { PageStoreType } from "@/store/TabPageStoreManager";
import { NotesListPageStore } from "@/store/pages/NotesListPageStore";
import { CollectionsListPageStore } from "@/store/pages/CollectionsListPageStore/CollectionsListPageStore";
import { CollectionsViewPageStore } from "@/store/pages/CollectionsViewPageStore";
import { SearchPageStore } from "@/store/pages/SearchPageStore/SearchPageStore";
import { AgentSearchPageStore } from "@/store/pages/AgentSearchPageStore";
import { TemplatesListPageStore } from "@/store/pages/TemplatesListPageStore";
import { TemplatesViewPageStore } from "@/store/pages/TemplatesViewPageStore";
import { TrashPageStore } from "@/store/pages/TrashPageStore/TrashPageStore";
import { NotesViewPageStore } from "@/store/pages/NotesViewPageStore/NotesViewPageStore";
import { SessionsListPageStore } from "@/store/pages/SessionsListPageStore";
import { SessionsViewPageStore } from "@/store/pages/SessionsViewPageStore";
import { AudioRecordingsListPageStore } from "@/store/pages/AudioRecordingsListPageStore";
import { useTabContext } from "@/components/layout/tab-context";

type PageStoreMap = {
  notesListPage: NotesListPageStore;
  notesViewPage: NotesViewPageStore;
  collectionsListPage: CollectionsListPageStore;
  collectionsViewPage: CollectionsViewPageStore;
  searchPage: SearchPageStore;
  agentSearchPage: AgentSearchPageStore;
  templatesListPage: TemplatesListPageStore;
  templatesViewPage: TemplatesViewPageStore;
  trashPage: TrashPageStore;
  sessionsListPage: SessionsListPageStore;
  sessionsViewPage: SessionsViewPageStore;
  audioRecordingsListPage: AudioRecordingsListPageStore;
};

export const useTabPageStore = <T extends PageStoreType>(pageType: T): PageStoreMap[T] => {
  const { pageStore } = useAppStore();
  const { activeTab, activeTabPath } = useTabContext();

  const store = useMemo(() => {
    const result = pageStore.getPageStore(activeTab, activeTabPath, pageType);
    return result as PageStoreMap[T];
  }, [activeTab, activeTabPath, pageType, pageStore]);

  return store;
};
